module.exports = __webpack_public_path__ + "assets/rent-black.18dc885b.svg";